import { Dispatcher396y2mcz9r128 as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/SavePartyCommand.mjs';
import { Dispatcherb76d0p5pxiow as Dispatcher_0 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pin/SavePinCommand.mjs';
import { Dispatcher39hthxqv8voqz as Dispatcher_1 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/player/SavePlayerCommand.mjs';
import { Dispatcher27uwezb7p8fpg as Dispatcher_2 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/GrantDiscordAccessCommand.mjs';
import { Dispatcher3r3trxa1ofgr6 as Dispatcher_3 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/secret/DeleteSecretCommand.mjs';
import { Dispatcher2txct93ff9b99 as Dispatcher_4 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pin/DeletePinCommand.mjs';
import { Dispatchernurlbopdkn3a as Dispatcher_5 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/SpinCommand.mjs';
import { Dispatchernmy2not8m2c7 as Dispatcher_6 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pairassignmentdocument/SavePairAssignmentsCommand.mjs';
import { Dispatcher2jh9je6zwmtr7 as Dispatcher_7 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/DeletePartyCommand.mjs';
import { Dispatcher3kdydho2ojhnk as Dispatcher_8 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/SaveSlackIntegrationCommand.mjs';
import { Dispatcher1dgi8c7arrsv1 as Dispatcher_9 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/player/DeletePlayerCommand.mjs';
import { Dispatcher3ngwv5mtnm33a as Dispatcher_10 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/ApplyBoostCommand.mjs';
import { Dispatcher3f3rv68jjbf7x as Dispatcher_11 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/secret/CreateSecretCommand.mjs';
import { Dispatcher2k7js8ct0qtp5 as Dispatcher_12 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pairassignmentdocument/DeletePairAssignmentsCommand.mjs';
import { Dispatchervu4hb3oerxrm as Dispatcher_13 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/GrantSlackAccessCommand.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ClientDispatcherClass;
function ClientDispatcher() {
  if (ClientDispatcherClass === VOID) {
    class $ {
      constructor(sdkDispatcher) {
        this.$$delegate_0__1 = sdkDispatcher;
      }
      *perform_6121ed_k$(command, $completion) {
        return yield* this.$$delegate_0__1.perform_6121ed_k$(command, $completion);
      }
      *perform_ie8b11_k$(command, $completion) {
        return yield* this.$$delegate_0__1.perform_ie8b11_k$(command, $completion);
      }
      *perform_ld878o_k$(command, $completion) {
        return yield* this.$$delegate_0__1.perform_ld878o_k$(command, $completion);
      }
      *perform_pua694_k$(command, $completion) {
        return yield* this.$$delegate_0__1.perform_pua694_k$(command, $completion);
      }
      *perform_ugstfq_k$(command, $completion) {
        return yield* this.$$delegate_0__1.perform_ugstfq_k$(command, $completion);
      }
      *perform_3d6euo_k$(command, $completion) {
        return yield* this.$$delegate_0__1.perform_3d6euo_k$(command, $completion);
      }
      *perform_lr39io_k$(command, $completion) {
        return yield* this.$$delegate_0__1.perform_lr39io_k$(command, $completion);
      }
      *perform_8cwak8_k$(command, $completion) {
        return yield* this.$$delegate_0__1.perform_8cwak8_k$(command, $completion);
      }
      *perform_512in8_k$(command, $completion) {
        return yield* this.$$delegate_0__1.perform_512in8_k$(command, $completion);
      }
      *perform_pl0x9_k$(query, $completion) {
        return yield* this.$$delegate_0__1.perform_pl0x9_k$(query, $completion);
      }
      *perform_rcf1c6_k$(command, $completion) {
        return yield* this.$$delegate_0__1.perform_rcf1c6_k$(command, $completion);
      }
      *perform_65q8nq_k$(command, $completion) {
        return yield* this.$$delegate_0__1.perform_65q8nq_k$(command, $completion);
      }
      *perform_proxak_k$(command, $completion) {
        return yield* this.$$delegate_0__1.perform_proxak_k$(command, $completion);
      }
      *perform_4hsz5q_k$(command, $completion) {
        return yield* this.$$delegate_0__1.perform_4hsz5q_k$(command, $completion);
      }
      *perform_5vsnf2_k$(command, $completion) {
        return yield* this.$$delegate_0__1.perform_5vsnf2_k$(command, $completion);
      }
      *perform_har7xx_k$(command, $completion) {
        return yield* this.$$delegate_0__1.perform_har7xx_k$(command, $completion);
      }
    }
    initMetadataForClass($, 'ClientDispatcher', VOID, VOID, [Dispatcher(), Dispatcher_0(), Dispatcher_1(), Dispatcher_2(), Dispatcher_3(), Dispatcher_4(), Dispatcher_5(), Dispatcher_6(), Dispatcher_7(), Dispatcher_8(), Dispatcher_9(), Dispatcher_10(), Dispatcher_11(), Dispatcher_12(), Dispatcher_13()], [1]);
    ClientDispatcherClass = $;
  }
  return ClientDispatcherClass;
}
//region block: exports
export {
  ClientDispatcher as ClientDispatcher1p2vginamq4dq,
};
//endregion

//# sourceMappingURL=ClientDispatcher.mjs.map
